export class Company {
  constructor(
    public hash?: string,
    public commercialName?: string,
    public businessName?: string,
    public taxNumber?: string
  ) { }

  clone() {
    return new Company(
      this.hash,
      this.commercialName,
      this.businessName,
      this.taxNumber
    );
  }
}
